import { InsightsColourMap } from '@percent/domain/insights'

// Locked donation-category → colour mapping (NEX-587). Keys are the canonical
// donation-category series keys returned by the `donations` insights metrics; any
// series key not listed here falls back to the Lemonade palette by index. Shared by
// the donations dashboard and the ported giving employee-donations report (NEX-727).
export const DONATION_COLOUR_MAP: InsightsColourMap = {
  grant: '#FF7557', // fox
  corporate_donation: '#81E1DA', // frog
  consumer_giving: '#F8BD3B', // canary
  employee_impact: '#8B4AFF', // octopus
  direct: '#72BEF4', // jay
  uncategorised: '#0F7EA0' // kingfisher
}

// Review-status → colour for the grants Reviews report. Keys are the report's DERIVED
// status buckets (the backend folds the source `cancelled` / `wont_do` into one
// `cancelled`, and computes `overdue` per request), so they are stable enough to pin:
// done reads as the healthy majority, overdue as the thing to act on.
export const REVIEW_STATUS_COLOUR_MAP: InsightsColourMap = {
  done: '#8B4AFF', // octopus
  overdue: '#FF7557', // fox
  cancelled: '#81E1DA', // frog
  todo: '#72BEF4' // jay
}
